import {FETCH_PEOPLE_LEVEL_IN_BRAND, FETCH_PEOPLE_LEVEL_IN_BRAND_SUCCESS, FETCH_PEOPLE_LEVEL_IN_BRAND_ERROR, UPDATE_PEOPLE_LEVEL_IN_BRAND, UPDATE_PEOPLE_LEVEL_IN_BRAND_SUCCESS, UPDATE_PEOPLE_LEVEL_IN_BRAND_ERROR, RESET_UPDATE_PEOPLE_LEVEL_IN_BRAND} from "constants/ActionTypes";

export const fetchPeopleLevelInBrand = () => {
  return {
    type: FETCH_PEOPLE_LEVEL_IN_BRAND,
  }
};

export const fetchPeopleLevelInBrandSuccess = (rateCardList) => {
  return {
    type: FETCH_PEOPLE_LEVEL_IN_BRAND_SUCCESS,
    payload: rateCardList,
  }
};

export const fetchPeopleLevelInBrandError = (error) => {
  return {
    type: FETCH_PEOPLE_LEVEL_IN_BRAND_ERROR,
    payload: error
  }
};

export const updatePeopleLevelInBrand = (params) => {
  return {
    type: UPDATE_PEOPLE_LEVEL_IN_BRAND,
    params,
  }
};

export const updatePeopleLevelInBrandSuccess = (payload) => {
  return {
    type: UPDATE_PEOPLE_LEVEL_IN_BRAND_SUCCESS,
    payload,
  }
};

export const updatePeopleLevelInBrandError = (error) => {
  return {
    type: UPDATE_PEOPLE_LEVEL_IN_BRAND_ERROR,
    payload: error
  }
};

export const resetUpdatePeopleLevelInBrand = () => {
  return {
    type: RESET_UPDATE_PEOPLE_LEVEL_IN_BRAND,
  }
};
